import { NRLogger as a } from "./contact-channels45.js";
import { attempt as s } from "./contact-channels54.js";
const n = async (r = !1) => {
  if (r) return !0;
  const { data: t, error: e } = await s(
    fetch("https://c2c-service.care.vpsvc.com/servicecheck", {
      method: "GET",
      signal: AbortSignal.timeout(5e3)
    })
  );
  return e ? (a.error("Contact Channels: CallMeSpam", {
    ...e
  }), !1) : (a.info("Contact Channels: CallMeSpam", {
    status: t.status,
    success: t.status === 200
  }), t.status === 200);
};
export {
  n as checkCallMeSpamProtection
};
//# sourceMappingURL=contact-channels74.js.map
